import axios from 'axios';
import { API_BASE_URL } from './constants';
import { clearAuthTokens } from './tokenStorage';
import { AuthTokens } from './types';

export const redirectToLogin = () => {
  clearAuthTokens();
  window.location.href = '/login';
};

export const refreshAccessToken = async (token: string) => {
  const response = await axios.post<AuthTokens>(`${API_BASE_URL}/auth/refresh-token`, { token });
  return response.data;
};
